import {createRouter, createWebHistory} from 'vue-router'

const Layout = () => import('../views/layout/index.vue')
const routes = [
    {
        path: '/',
        component: Layout,
        children: [
            {
                path: '',
                meta: {
                    title: '山东兆通业绩统计系统',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/index/index')
            },
        ]
    },{
        path: '/contract',
        component: Layout,
        children: [
            {
                path: 'list',
                meta: {
                    title: '合同列表',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/contract/list')
            },{
                path: 'performance',
                meta: {
                    title: '业绩记录',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/contract/performance')
            },
        ]
    },{
        path: '/statistics',
        component: Layout,
        children: [
            {
                path: 'department',
                meta: {
                    title: '团队排名',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/statistics/department')
            },{
                path: 'personal',
                meta: {
                    title: '个人排名',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/statistics/personal')
            },{
                path: 'break_record',
                meta: {
                    title: '破蛋记录',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/statistics/break_record')
            },{
                path: 'breakratio',
                meta: {
                    title: '破蛋率',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/statistics/breakratio')
            },{
                path: 'target',
                meta: {
                    title: '目标达成',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/statistics/target')
            },{
                path: 'performance',
                meta: {
                    title: '业绩统计',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/statistics/performance')
            },{
                path: 'heightest',
                meta: {
                    title: '业绩刷新记录',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/statistics/heightest')
            },{
                path: 'receivables',
                meta: {
                    title: '应收款',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/statistics/receivables')
            },{
                path: 'elite',
                meta: {
                    title: '精英/兵团队',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/statistics/elite')
            },{
                path: 'department_record',
                meta: {
                    title: '团队纪录',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/statistics/department_record')
            },
        ]
    },
    {
        path: '/employee',
        component: Layout,
        children: [
            {
                path: 'list',
                meta: {
                    title: '员工列表',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/employee/list.vue')
            },{
                path: 'lizhi',
                meta: {
                    title: '离职员工',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/employee/lizhi.vue')
            }
        ]
    },
    {
        path: '/item',
        component: Layout,
        children: [
            {
                path: 'list/:type',
                meta: {
                    title: '',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/item/list')
            },{
                path: 'list/:position_type',
                meta: {
                    title: '',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/item/list')
            },{
                path: 'list/:position',
                meta: {
                    title: '',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/item/list')
            },{
                path: 'list/:contract_type',
                meta: {
                    title: '',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/item/list')
            },
        ]
    },
    {
        path: '/index',
        meta: {
            title: '测试'
        },
        component: () => import(/* webpackChunkName:'second' */ '../views/index/index')
    },
    {
        path: '/operator',
        component: Layout,
        children: [
            {
                path: 'list',
                meta: {
                    title: '操作员列表',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/operator/list.vue')
            }, {
                path: 'group',
                meta: {
                    title: '操作员组',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/operator/group.vue')
            },{
                path: 'employeegroup',
                meta: {
                    title: '员工组',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/operator/employeegroup.vue')
            }
        ]
    },
    {
        path: '/pk',
        component: Layout,
        children: [
            {
                path: 'list',
                meta: {
                    title: 'PK列表',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/pk/list.vue')
            }, {
                path: 'result',
                meta: {
                    title: 'PK结果',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/pk/result.vue')
            }
        ]
    },
    {
        path: '/target',
        component: Layout,
        children: [
            {
                path: 'department',
                meta: {
                    title: '团队目标',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/target/department.vue')
            }
        ]
    },
    {
        path: '/table',
        component: Layout,
        children: [
            {
                path: 'list',
                meta: {
                    title: '表格列表',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/table/list.vue')
            }
        ]
    },
    {
        path: '/setting',
        component: Layout,
        children: [
            {
                path: 'list',
                meta: {
                    title: '参数设置',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/setting/list')
            },
            {
                path: 'banner',
                meta: {
                    title: 'banner设置',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/setting/banner')
            },
            {
                path: 'article/:type',
                meta: {
                    title: '用户协议/隐私政策',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/setting/article')
            },
            {
                path: 'break_amount',
                meta: {
                    title: '破蛋业绩',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/setting/break_amount')
            },
            {
                path: 'managefield',
                meta: {
                    title: '参数管理',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/setting/managefield')
            },
            {
                path: 'params',
                meta: {
                    title: '平台参数',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/setting/params')
            },
            {
                path: 'wechat',
                meta: {
                    title: '微信相关',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/setting/wechat')
            },
            {
                path: 'text_fix',
                meta: {
                    title: '文本表情',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/setting/text_fix')
            },
            {
                path: 'break_date',
                meta: {
                    title: '破蛋半程日期',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/setting/break_date')
            },
        ]
    },
    {
        path: '/login',
        meta: {
            title: '登录'
        },
        component: () => import(/* webpackChunkName:'second' */ '../views/index/login')
    }, {
        path: '/menu',
        component: Layout,
        children: [
            {
                path: 'list',
                meta: {
                    title: '菜单列表',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/menu/list.vue')
            },
            {
                path: 'employee',
                meta: {
                    title: '员工菜单',
                    login: 1
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/menu/employee.vue')
            }
        ]
    },
    /* 本段代码放在最后，未设置路由的地址跳转404 */
    {
        path: '/:catchAll(.*)',
        redirect: '/404'
    },
    {
        path: '/404',
        component: Layout,
        children: [
            {
                path: '',
                meta: {
                    title: '页面不存在'
                },
                component: () => import(/* webpackChunkName:'second' */ '../views/404')
            },
        ]
    },
    /** 本段代码放在最后，未设置路由的地址跳转404 */
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
